import React from 'react';
import { useInView } from 'react-intersection-observer';
import { ImageTransformationTemplateEntity } from '../types';
import Image from './image';
import lazyStyles from './lazyImage.module.pcss';

function LazyImage({ src, alt, className, transformationTemplates, onLoad }: ImageProps): React.ReactElement {
  const [ref, inView] = useInView({
    triggerOnce: true,
    rootMargin: '0px 0px 100px 0px'
  });

  return (
    <div ref={ref} className={`${lazyStyles['lazy-wrapper']} ${className || ''}`} data-inview={inView}>
      {inView ? (
        <Image className={lazyStyles['lazy-wrapper__image']} {...{ src, alt, transformationTemplates, onLoad }} />
      ) : null}
    </div>
  );
}

interface ImageProps {
  src: string;
  alt?: string;
  className?: string;
  transformationTemplates?: ImageTransformationTemplateEntity;
  onLoad?: (e: React.SyntheticEvent<HTMLImageElement, Event>) => void;
}

export default LazyImage;
